<template>
  <div>
    <div v-for="displayField in displayFields" :key="displayField.label">
      <!-- eslint-disable-next-line -->
      <p :style="{ color: setLabelColor }" v-html="formatText(displayField.label)"></p>:
      <!-- eslint-disable-next-line -->
      <p :style="{ color: setValueColor }" v-html="formatText(displayField.value)"></p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { displayField, theme } from "@entersekt/types/build/3-5-0/endpoint";

const black = "#2c3e50";

export default defineComponent({
  name: "DisplayFields",

  inject: ["formatTextFunction"],

  data() {
    return {
      formatText: this.formatTextFunction,
    };
  },

  props: {
    displayFields: {
      required: true,
      type: Array as PropType<displayField[]>,
    },
    theme: {
      type: Object as PropType<theme>,
    },
  },

  computed: {
    setLabelColor(): string {
      return this.theme?.displayFieldLabelTextColor
        ? this.theme?.displayFieldLabelTextColor
        : black;
    },
    setValueColor(): string {
      return this.theme?.displayFieldValueTextColor
        ? this.theme?.displayFieldValueTextColor
        : black;
    },
  },
});
</script>

<style scoped>
p {
  display: inline;
  word-wrap: break-word;
}
</style>
